/*
 * MDB shim for MDBModal
 * Files currently importing this symbol from "mdbreact":
 * - src/App.jsx
 * - src/Seating/Accounts/accountDetail.jsx
 * - src/Seating/Orders/ATPView.jsx
 * - src/Seating/Orders/collectionsView.jsx
 * - src/Seating/Patient/PatientViewComponents/CreateQuoteModalFromTicket.jsx
 * - src/Seating/Patient/PatientViewComponents/createNoteModal.jsx
 * - src/Seating/Patient/PatientViewComponents/notesTab.jsx
 * - src/Seating/Patient/PatientViewComponents/patientInformationTab.jsx
 * - src/Seating/Patient/PatientViewComponents/pverifyModal.jsx
 * - src/Seating/Patient/patientInformationView.jsx
 * - src/Seating/Patient/patientOrderView.jsx
 * - src/Seating/Reports/reports.jsx
 * - src/Seating/Settings/stateSalesTax.jsx
 */

import MUIDialog from "@mui/material/Dialog";
import MUIModal from "@mui/material/Modal";

export default function MDBModal({
  children,
  isOpen,
  toggle,
  onClose,
  ...rest
}) {
  function handleClose(...args) {
    onClose?.(...args);
    toggle?.(...args);
  }

  return (
    <MUIDialog open={Boolean(isOpen)} onClose={handleClose} {...rest}>
      {children}
    </MUIDialog>
  );
}
